import(/* webpackMode: "eager", webpackExports: ["LongFormContent","LegacyContent","default"] */ "/vercel/path0/apps/www/app/[locale]/(site)/(en-only)/resources/[slug]/_components/single-resource-content/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/www/app/[locale]/(site)/(en-only)/resources/[slug]/_components/single-resource-page-header/style.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/www/app/[locale]/(site)/(en-only)/resources/[slug]/_components/resource-view/view.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["Card"] */ "/vercel/path0/packages/mds-react/dist/components/card/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/mds-react/dist/components/flight-icon/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["PartnerCard"] */ "/vercel/path0/packages/mds-react/dist/patterns/card/partner-card/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Thumbnail","PersonThumbnail","LogoThumbnail"] */ "/vercel/path0/packages/mds-react/dist/patterns/card/thumbnails/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["CopyButton"] */ "/vercel/path0/packages/mds-react/dist/patterns/copy-button/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["RelatedContent"] */ "/vercel/path0/packages/mds-react/dist/patterns/related-content/index.js");
